export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-next-10ed486ba826ce3c51f826d0464815d6.svg";